export function AcceptIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      height="16px"
      width="16px"
      viewBox="0 0 490 490"
      xmlSpace="preserve"
    >
      <polygon points="452.253,28.326 197.831,394.674 29.044,256.875 0,292.469 207.253,461.674 490,54.528" />
    </svg>
  );
}
